import { render } from "./group.html?vue&type=template&id=639b9f16&external"
import script from "./group.js?vue&type=script&lang=js&external"
export * from "./group.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__